import {RootStore, store} from '../redux/store';

export default function getCurrentUnitLink() {
  const allState: RootStore = store.getState();
  const allLinks = allState.units.unitLinks;
  const currentLink = allLinks.filter((link) => link.isDefault === true)[0];

  return currentLink;
}
